import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import { Row, Col,Card, CardBody, Button, Label, FormGroup } from "reactstrap";


const validationSchema = Yup.object({
  Inputname: Yup.string().required("Enter your name"),
  mobileNumber: Yup.string().required("Enter your Number"),
  email:Yup.string().required("Enter your E-mail"),
  purchasePlan: Yup.string().required("Enter your Subject"),
  // progress: Yup.string().required("Select your State"),
});



const onSubmit = async (values) => {
  // console.log(values);
//   const user = JSON.parse(localStorage.getItem("userlogindata"));

  const userProfileData = {
   
    name: values.Inputname,
  
  };


  console.log(userProfileData);


  axios
    // .patch(`${Constant.api_url}users-profile/update/${user.user.id}`, userProfileData, {
    //   headers: authHeader(),
    // })
    .then((res) => {
      toast.success("manage account updated successfully");
    })
    .catch((e) => {
      // toast.e(data.message);
      // console.log(e);
    });
};

function Feedback() {
  const [Inputname, setInputname] = useState("");
  const [mobileNumber, setmobileNumber] = useState("");
  const [email, setemail] = useState("");
  const [purchasePlan, setpurchasePlan] = useState("");
 const [progress, setprogress] = useState("");

 
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    // const user = JSON.parse(localStorage.getItem("userlogindata"));
    //const name = user.user.name;

    // axios
    //   .get(`${Constant.api_url}users-profile/getUser/${user.user.id}`, {
    //     headers: authHeader(),
    //   })
      // .then((res) => {
        setInputname();
        setmobileNumber();
       setemail();
        setpurchasePlan();
       setprogress();

      // })
      // .catch((e) => {
      //   // toast.e(data.message);
      //   // console.log(e);
      // });

   
  }, []);
  return (
    <Row className="mb-4">
   
    <Col xxs="12" className="mb-3">
      <Card>
        <CardBody>
          <Formik
            enableReinitialize // missing piece!!
            initialValues={{
              Inputname: "",
              mobileNumber: "",
              email:"",
              purchasePlan: "",
              progress: ""
            }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              setFieldValue,
              touched,
              values,
              errors,
            }) => (
              <form
                autoComplete="off"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <div className="">
                  <FormGroup className="error-l-100">
                    <Label>
                    NAME:
                    </Label>

                    <Field
                      type="text"
                      name="Inputname"
                      id="Inputname"
                      className="form-control"
                      onChange={(event) => {
                        const desc = event.target.value;
                        setFieldValue("Inputname", desc);
                      }}
                    />
                    {errors.Inputname && touched.Inputname ? (
                      <div className="invalid-feedback d-block">
                        {errors.Inputname}
                      </div>
                    ) : null}
                  </FormGroup>
                  <FormGroup className="error-l-100">
                    <Label>
                    MOBILE NUMBER:
                    </Label>

                    <Field
                      type="text"
                      name="mobileNumber"
                      id="mobileNumber"
                      className="form-control"
                    
                      onChange={(event) => {
                        const desc = event.target.value;
                        setFieldValue("mobileNumber", desc);
                      }}
                    />
                    {errors.mobileNumber && touched.mobileNumber ? (
                      <div className="invalid-feedback d-block">
                        {errors.mobileNumber}
                      </div>
                    ) : null}
                  </FormGroup>

               
                  <FormGroup className="error-l-100">
                    <Label>
                    E-MAIL:
                    </Label>

                    <Field
                      type="text"
                      name="email"
                      id="email"
                      className="form-control"
                      onChange={(event) => {
                        const desc = event.target.value;
                        setFieldValue("email", desc);
                      }}
                    />
                     {errors.email && touched.email ? (
                      <div className="invalid-feedback d-block">
                        {errors.email}
                      </div>
                    ) : null}
                  </FormGroup>
                  <FormGroup className="error-l-100">
                    <Label>
                    SUBJECT:
                    </Label>

                    <Field
                      type="text"
                      name="purchasePlan"
                      id="purchasePlan"
                      className="form-control"
                      onChange={(event) => {
                        const desc = event.target.value;
                        setFieldValue("purchasePlan", desc);
                      }}
                    />
                    {errors.purchasePlan && touched.purchasePlan ? (
                      <div className="invalid-feedback d-block">
                        {errors.purchasePlan}
                      </div>
                    ) : null}
                  </FormGroup>
                  <FormGroup className="error-l-100">
                    <Label>
                    MESSAGE:
                    </Label>

                    <textarea
                      type="text"
                      name="progress"
                      id="progress"
                      className="form-control"
                      onChange={(event) => {
                        const desc = event.target.value;
                        setFieldValue("progress", desc);
                      }}
                    />
                    {/* {errors.progress && touched.progress ? (
                      <div className="invalid-feedback d-block">
                        {errors.progress}
                      </div>
                    ) : null} */}
                  </FormGroup>
                  
                </div>
             

                <div className="">
                  <Button
                    color="primary"
                    type="submit"
                    className=" form-input-btn"
                  >
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </Col>
  </Row>
  );
}

export default Feedback;
